module.exports = __webpack_public_path__ + "img/proteinStructure_thumb.ad004bee.png";